import React, { useState } from "react";
import { LayoutRectangle, View, ViewProps } from "react-native";

// This component inserts an absolutely positioned view within a flex view
// in order to maintain correct dimensions regardless of its content size
export const AbsoluteView = ({
  style,
  contentStyle,
  children,
  ...props
}: ViewProps & { contentStyle?: ViewProps["style"] }) => {
  const [dimensions, setDimensions] = useState<LayoutRectangle>();
  return (
    <View
      style={[{ flex: 1 }, style]}
      onLayout={(ev) => setDimensions(ev.nativeEvent.layout)}
    >
      <View
        style={[
          {
            position: "absolute",
            width: dimensions?.width,
            height: dimensions?.height,
          },
          contentStyle,
        ]}
        {...props}
      >
        {children}
      </View>
    </View>
  );
};
